@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.calls

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint

object CallDriverVoipEndpoint : EndPoint<CallDriverVoipEndpoint.Request, CallDriverVoipEndpoint.Response>() {
    class Request(
        val rideId: KmmLong?
    )

    class Response(
        val credentials: VoipCallCredentialsDto?
    )
}
